export default __webpack_public_path__ + "static/media/jaggedcut1.adc06cf7.png";